import { classInstance } from '@/shared/helpers/helpers';

export class ProductCode {
	private readonly element: HTMLElement | null;
	private readonly duration = 3000;
	private value: HTMLElement;

	constructor(element: HTMLElement | null) {
		this.element = element;
		this.init();
	}

	private handleClick = async () => {
		const string: string = this.value.innerText;
		const clipboardItem = new ClipboardItem({ 'text/plain': string });
		await navigator.clipboard.write([clipboardItem]);
		window.app.notify.append({
			id: 'notify-product-share',
			delay: this.duration,
			content: 'Артикул скопирован',
		});
	};

	private bindEvents = (): void => {
		this.element.addEventListener('click', this.handleClick);
	};

	private unbindEvents = (): void => {
		this.element.removeEventListener('click', this.handleClick);
	};

	public init = (): void => {
		if (!this.element) return;

		classInstance.set(this.element, { productInfoCode: this });

		this.value = this.element.querySelector('.product-code__value');

		this.bindEvents();
	};

	public destroy = (): void => {
		if (!this.element) return;

		this.unbindEvents();
		classInstance.del(this.element, 'productInfoCode');
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
